import React from 'react';
import { Button } from './ui/button';
import { ChevronDown, MapPin, Home, Shield } from 'lucide-react';
import { companyInfo, stats } from '../data/mock';

const HeroSection = () => {
  const scrollToProperties = () => {
    document.querySelector('#propiedades')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="inicio" data-testid="hero-section" className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background image with overlay */}
      <div className="absolute inset-0">
        <img
          src="https://static.prod-images.emergentagent.com/jobs/e8cf70d2-e53e-4ea5-b12f-f14ccb00398e/images/a0b1dc547008a7e296aba816421cd5ed4e65c0bb749437eeed95626ce1afb9dc.png"
          alt="Luxury villa"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/60 to-black/30" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 sm:px-12 lg:px-24 py-32 w-full">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            <div className="inline-flex items-center gap-2 border border-[#D4A520]/30 px-5 py-2 mb-8">
              <MapPin className="w-4 h-4 text-[#D4A520]" />
              <span className="text-sm font-medium text-white/80 uppercase tracking-widest">Piura, Perú</span>
            </div>

            <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold leading-none mb-8 tracking-tight">
              <span className="text-white">Encuentra tu</span>
              <span className="block text-gold-gradient mt-2">hogar ideal</span>
              <span className="text-white">en Piura</span>
            </h1>

            <p className="text-lg text-white/60 mb-10 max-w-lg leading-relaxed" style={{ fontFamily: 'Outfit, sans-serif' }}>
              {companyInfo.description}
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-16">
              <Button
                onClick={scrollToProperties}
                data-testid="hero-cta-button"
                className="bg-[#D4A520] hover:bg-[#FFD700] text-black font-semibold px-10 py-6 text-base rounded-none transition-all duration-300 hover:shadow-xl hover:shadow-[#D4A520]/20 hover:-translate-y-[2px] uppercase tracking-wider"
                style={{ fontFamily: 'Outfit, sans-serif' }}
              >
                Ver Propiedades
              </Button>
              <a
                href={`https://wa.me/${companyInfo.whatsapp}?text=Hola, me interesa conocer más sobre sus propiedades`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button
                  variant="outline"
                  data-testid="hero-contact-button"
                  className="border border-[#D4A520]/40 bg-transparent text-[#D4A520] hover:bg-[#D4A520] hover:text-black font-semibold px-10 py-6 text-base rounded-none transition-all duration-300 w-full sm:w-auto uppercase tracking-wider"
                  style={{ fontFamily: 'Outfit, sans-serif' }}
                >
                  Contactar Asesor
                </Button>
              </a>
            </div>

            {/* Trust badges */}
            <div className="flex flex-wrap gap-8">
              <div className="flex items-center gap-3 text-white/50">
                <div className="w-10 h-10 border border-[#D4A520]/30 flex items-center justify-center">
                  <Home className="w-5 h-5 text-[#D4A520]" />
                </div>
                <span className="text-sm uppercase tracking-wider" style={{ fontFamily: 'Outfit, sans-serif' }}>Propiedades Verificadas</span>
              </div>
              <div className="flex items-center gap-3 text-white/50">
                <div className="w-10 h-10 border border-[#D4A520]/30 flex items-center justify-center">
                  <Shield className="w-5 h-5 text-[#D4A520]" />
                </div>
                <span className="text-sm uppercase tracking-wider" style={{ fontFamily: 'Outfit, sans-serif' }}>Inversión Segura</span>
              </div>
            </div>
          </div>

          {/* Right Content - Stats Cards */}
          <div className="hidden lg:grid grid-cols-2 gap-5">
            {stats.map((stat, index) => (
              <div
                key={index}
                data-testid={`stat-card-${index}`}
                className={`bg-black/40 backdrop-blur-md p-8 border border-[#D4A520]/20 transition-all duration-500 hover:border-[#D4A520]/50 hover:bg-black/60 ${
                  index === 0 ? 'translate-y-8' : index === 3 ? '-translate-y-8' : ''
                }`}
              >
                <div className="text-4xl font-bold text-[#D4A520] mb-2">{stat.value}</div>
                <div className="text-white/50 text-sm uppercase tracking-wider" style={{ fontFamily: 'Outfit, sans-serif' }}>{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <button
          onClick={scrollToProperties}
          className="text-[#D4A520]/60 hover:text-[#D4A520] transition-colors"
          data-testid="scroll-indicator"
        >
          <ChevronDown className="w-8 h-8" />
        </button>
      </div>
    </section>
  );
};

export default HeroSection;
